// Invitation Action
export const SET_INVITATION_DETAILS = "SET_INVITATION_DETAILS";
export const SET_INVITATION_OPEN = "SET_INVITATION_OPEN";
export const SET_INVITATION_PREVIEW = "SET_INVITATION_PREVIEW";
export const SET_INVITATION_THEME = "SET_INVITATION_THEME";
export const INVITATION_LOADING = "INVITATION_LOADING";
